import { isoToDateTime } from "../../../shared/filters/isodate";

const roles = [
    { name: "client", description: "Клиент" },
    { name: "admin", description: "Админ" },
];

const translation = {
    "user:account:auth": "Пользователь авторизовался",
    "user:account:auth:social": "Пользователь авторизовался через соц. сеть",
    "user:account:auth:token": "Пользователь авторизовался через токен",
    "user:account:auth:api_key": "Пользователь  авторизовался через API ключ",
    "user:account:logout": "Пользователь разлогинился",
    "user:account:created": "Пользователь создан",
    "user:account:register_complete": "Пользователь завершил регистрацию",
    "user:account:verify_phone": "Пользователь подтвердил номер телефона",
    "user:account:verify_email": "Пользователь подтвердил email",
    "user:account:subscribe_push": "Пользователь подписался на пуши",
    "user:account:update_profile": "Пользователь обновил профиль",
    "user:account:set_credit_score": "Пользователь обновил кредитный рейтинг",
    "user:account:set_app_rating": "Пользователь поставил оценку приложению",
    "user:account:change_password": "Пользователь изменил пароль",
    "user:account:restore_password": "Пользователь восстановил пароль",

    "user:offers:fetch": "Пользователь получил список офферов",
    "user:offers:choose": "Пользователь перешел на оффер",

    "user:offers:score:fetch": "Пользователь получил список офферов (кредитный рейтинг)",
    "user:offers:score:choose": "Пользователь перешел на оффер (кредитный рейтинг)",

    "user:applications:fetch": "Пользователь получил список заявок",
    "user:applications:update": "Пользователь обновил свою заявку",

    "user:lead:approved": "Пользователю пришел postback (Approve)",
    "user:lead:pending": "Пользователю пришел postback (Pending)",
    "user:lead:reject": "Пользователю пришел postback (Reject)",

    "user:sms:offer:send": "Пользователю отправлена СМС с оффером",
    "user:sms:code:send": "Пользователю отправлена СМС кодом подтверждения",
    "user:sms:showcase:send": "Пользователю отправлена СМС с витриной",
    "user:sms:restore:send": "Пользователю отправлена СМС кодом востановления",

    "user:email:offer:send": "Пользователю отправлен email с оффером",
    "user:email:code:send": "Пользователю отправлен email с кодом подтверждения",
    "user:email:showcase:send": "Пользователю отправлен email с витриной",
    "user:email:restore:send": "Пользователю отправлен email с кодом востановления",

    "user:push:offer:send": "Пользователю отправлен push с оффером",
    "user:push:code:send": "Пользователю отправлен email с кодом подтверждения",
    "user:push:showcase:send": "Пользователю отправлен email с витриной",
    "user:push:restore:send": "Пользователю отправлен email с кодом востановления",

    "user:payment:create": "Пользователю создан платеж",

    "admin:account:auth": "Админ авторизовался",
    "admin:account:logout": "Админ разлогинился",

    "admin:user:delete": "Админ удален",

    "admin:offer:create": "Админ создал оффер",
    "admin:offer:update": "Админ обновил оффер",
    "admin:offer:delete": "Админ удалил оффер",
    "admin:offer:change_order": "Админ изменил порядок офферов",

    "admin:trigger:create": "Админ создал триггер",
    "admin:trigger:update": "Админ обновил триггер",
    "admin:trigger:delete": "Админ удалил триггер",
    "admin:trigger:switch": "Админ включил/выключил триггер",

    "admin:notifications:set_chain_settings": "Админ изменил настройки цепочки",
    "admin:notifications:send_instant": "Админ создал расслыку",
    "admin:notifications:auto_registration": "Админ создал рассылку с авторегой",
    "admin:notifications:sms_with_auto_registration": "Админ создал рассылку с смс с авторегой",
};

export default {
    getRoles() {
        return roles;
    },
    getRoleByName(name) {
        return roles.find((role) => role.name === name);
    },
    translateEvent(event) {
        return translation.hasOwnProperty(event) ? translation[event] : event;
    },
    parseEvents(events) {
        events.forEach((item) => {
            item.utms = {
                utm_campaign: item.utm_campaign,
                utm_content: item.utm_content,
                utm_medium: item.utm_medium,
                utm_source: item.utm_source,
                utm_term: item.utm_term,
            };
            item.createdAtFormatted = isoToDateTime(item.created_at);
            item.userFormatted = item.user ? item.user.email : "Пользователь удален";
            item.eventFormatted = this.translateEvent(item.event);
            item.roleFormatted = this.getRoleByName(item.user_type).description;
        });
        return events;
    },

    parseEventList(events) {
        return events.map((item) => {
            return { name: item, description: this.translateEvent(item) };
        });
    },
};
